<template>
  <div>
    <van-cell
      :title="item.label"
      v-for="(item, index) in checkboxList"
      :key="item.id"
      :border="false"
      @click="clickCell(index)"
    >
      <template>
        <van-checkbox
          v-model="securityCheckboxData[item.key]"
          label-position="left"
          ref="refCheckbox"
          @change="changeCheckbox"
        >
        </van-checkbox>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkboxList: [
        {
          id: 0,
          label: "车辆和驾驶员证照是否齐全",
          key: "IsCertComplete",
        },
        {
          id: 1,
          label: "车辆是否已开展安全例检",
          key: "IsVehiclePrecedent",
        },
        {
          id: 2,
          label: "旅客行李安检是否异常",
          key: "IsCustomerBaggageAnomaly",
        },
        {
          id: 3,
          label: "旅客实名制查验是否异常",
          key: "IsCustomerRealNameException",
        },
        {
          id: 4,
          label: "出站是否系好安全带",
          key: "IsFastenSeatBelts",
        },
        {
          id: 5,
          label: "出站是否超员",
          key: "IsOverCustomer",
        },
      ],
      securityCheckboxData: {
        IsCertComplete: false,
        IsVehiclePrecedent: false,
        IsCustomerBaggageAnomaly: false,
        IsCustomerRealNameException: false,
        IsFastenSeatBelts: false,
        IsOverCustomer: false,
      },
    };
  },
  methods: {
    changeCheckbox() {
      this.$emit("changeCheckbox", this.securityCheckboxData);
    },
    clickCell(index) {
      this.$refs.refCheckbox[index].toggle();
    },
  },
  props: {
    title: {
      type: [String],
    },
  },
};
</script>

<style lang="less" scoped>
.van-cell {
  border-bottom: 1px solid #dddddd85;
  font-size: 0.42rem;

  .van-cell__title {
    display: flex;
    justify-items: flex-start;
    flex: 3;
  }
  .van-cell__value {
    .van-checkbox {
      justify-content: flex-end;
    }
  }
}
</style>
